// extracted by mini-css-extract-plugin
export default {"container":"ImgUpload_container__FubgA","title":"ImgUpload_title__ylkLl","image":"ImgUpload_image__N-IXA"};